import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { Input } from "../../../components/ui/input";
import { FormField, FormItem, FormControl, FormMessage } from "../../../components/ui/form";
import { User, Lock, Eye, EyeOff } from "lucide-react";

export const FormSignInEmail = () => {
    const { t } = useTranslation("signin");
    const { control } = useFormContext();
    const [showPassword, setShowPassword] = useState(false);
    
    return (
        <div className="space-y-4 w-full">
            <FormField
                control={control}
                name="email"
                rules={{ required: t("form.emailRequired") }}
                render={({ field }) => (
                    <FormItem>
                        <FormControl>
                            <div className="relative">
                                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground w-5 h-5" />
                                <Input 
                                    className="pl-10 h-10" 
                                    placeholder={t("form.emailPlaceholder")} 
                                    {...field} 
                                />
                            </div>
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="password"
                rules={{ required: t("form.passwordRequired") }}
                render={({ field }) => (
                    <FormItem>
                        <FormControl>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground w-5 h-5" />
                                <Input 
                                    type={showPassword ? "text" : "password"}
                                    className="pl-10 pr-10 h-10" 
                                    placeholder={t("form.passwordPlaceholder")} 
                                    {...field} 
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground focus:outline-none"
                                >
                                    {showPassword ? (
                                        <EyeOff className="w-5 h-5" />
                                    ) : (
                                        <Eye className="w-5 h-5" />
                                    )}
                                </button>
                            </div>
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
}